/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Cost_NoteInputs */

const en_mk_sol_cost_note = /** @type {(inputs: Mk_Sol_Cost_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI figure above is estimated from real run prices (Rp 130–500 per task) and is covered by the plan quota. Your exact number depends on how often your agents work.`)
};

const id_mk_sol_cost_note = /** @type {(inputs: Mk_Sol_Cost_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya AI di atas adalah perkiraan dari harga run nyata (Rp 130–500 per tugas) dan sudah termasuk kuota paket. Angka pastinya bergantung pada seberapa sering agen Anda bekerja.`)
};

/**
* | output |
* | --- |
* | "The AI figure above is estimated from real run prices (Rp 130–500 per task) and is covered by the plan quota. Your exact number depends on how often your age..." |
*
* @param {Mk_Sol_Cost_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_cost_note = /** @type {((inputs?: Mk_Sol_Cost_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Cost_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_cost_note(inputs)
	return en_mk_sol_cost_note(inputs)
});